import BaseServiceHttp from '../baseService'
class StatusReservas extends BaseServiceHttp {
  constructor(id) {
    const resource = 'status-reservas'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new StatusReservas(id)
